import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanTagProps as Props } from './types';

export const CurrentPlanTag = memo(({ className }: Props) => {
  const { selectedPlan, currentPlan, isPaid } = usePlanCardContext();
  if (
    (isPaid && currentPlan?.id !== selectedPlan?.id) ||
    (!isPaid && currentPlan?.metadata.is_free !== 'true')
  )
    return null;

  return (
    <Styled.Wrapper
      className={classnames('CurrentPlanTag', className)}
      sx={SX.root}
      label="Current Plan"
      variant="outlined"
      shape="rounded"
      color="success"
      size="small"
    />
  );
});

CurrentPlanTag.displayName = 'CurrentPlanTag';
